"use client";

import * as React from "react";

export const ReportHistoryEnabledContext = React.createContext<(enabled: boolean | null) => void>(
  () => {}
);

/**
 * Tells the command palette whether Version History is on, so its toggle can label itself. Flags
 * resolve under the project layout, below the palette, so they are reported up rather than read.
 */
export function useReportHistoryEnabled(enabled: boolean): void {
  const report = React.useContext(ReportHistoryEnabledContext);
  React.useEffect(() => {
    report(enabled);
    return () => report(null);
  }, [report, enabled]);
}
